import React from 'react';
import { TrendingUp, TrendingDown } from 'lucide-react';

const MetricCard = ({ icon: Icon, label, value, change, changeLabel, color, onClick, clickable = false }) => (
  <div 
    data-testid={`metric-card-${label?.toLowerCase().replace(/\s+/g, '-')}`}
    className={`bg-gradient-to-br from-[#2D063E] to-[#1a0527] border border-[#4A0A66]/50 rounded-xl p-4 ${clickable ? 'cursor-pointer hover:border-[#df1283]/50 transition-all hover:scale-[1.02]' : ''}`}
    onClick={clickable ? onClick : undefined}
  >
    <div className="flex items-start justify-between mb-2">
      <div 
        className="w-10 h-10 rounded-lg flex items-center justify-center"
        style={{ backgroundColor: `${color}20` }}
      >
        <Icon className="w-5 h-5" style={{ color }} />
      </div>
      {change !== undefined && (
        <span className={`text-xs px-2 py-1 rounded-full flex items-center gap-1 ${change >= 0 ? 'bg-green-500/20 text-green-400' : 'bg-red-500/20 text-red-400'}`}>
          {change >= 0 ? <TrendingUp className="w-3 h-3" /> : <TrendingDown className="w-3 h-3" />}
          {Math.abs(change)}%
        </span>
      )}
    </div>
    <p className="text-2xl font-bold text-white">{value}</p>
    <p className="text-xs text-[#FDF2F8]/50">{label}</p>
    {changeLabel && <p className="text-xs text-[#FF7901] mt-1">{changeLabel}</p>}
  </div>
);

export default MetricCard;
